import React from 'react';

const ContributionStats = ({ counts }) => {
  return (
    <div className="contribution-stats">
      <div className="contribution-stats-item">
        <span>Documents:</span>
        <span>{counts.titles.toLocaleString()}</span>
      </div>
      <div className="contribution-stats-item">
        <span>Focuses:</span>
        <span>{counts.focuses.toLocaleString()}</span>
      </div>
      <div className="contribution-stats-item">
        <span>Thoughts:</span>
        <span>{counts.thoughts.toLocaleString()}</span>
      </div>
    </div>
  );
};

export default ContributionStats;
